import { computed, watch, type ComputedRef, type Ref } from 'vue';
import { fetchAndCacheAvatarUrls, getCachedAvatarUrl } from 'src/views/admin/cognito-pay/utils/cognito-pay-utils';

export function usePersonAvatarUrl(entryId: Ref<string | null | undefined>, enabled: Ref<boolean>): ComputedRef<string> {
	watch(
		() => [enabled.value, entryId.value] as const,
		([isEnabled, id]) => {
			if (isEnabled && id) {
				void fetchAndCacheAvatarUrls([id]).catch(() => {
					// Keep the UI stable when the avatar lookup fails.
				});
			}
		},
		{ immediate: true }
	);

	return computed(() => getCachedAvatarUrl(entryId.value ?? undefined) ?? '');
}
